// extracted by mini-css-extract-plugin
export var footerContainer = "F_bV";
export var footerContent = "F_bX";
export var footerDisclosure = "F_bY";
export var menu = "F_bW";